import React from 'react'
import {TextField} from '@material-ui/core';
import getObjectValue from 'libs/getObjectValue'
import PropTypes from 'prop-types';
import {Autocomplete} from "@material-ui/lab";
import Tr from "translations/Translations";


function OrganizationsSelect(
    {
        formikProps,
        id,
        label,
        items,
        noError,
        className,
        required,
        disabled,
        onChange = () => {
        },
        onChipClick,
        chipTitle
    }) {


    const errorValue = getObjectValue(id, formikProps.errors, '')
    //const touched = getObjectValue(id, formikProps.touched, false)
    const value = getObjectValue(id, formikProps.values, [])
    const editable = getObjectValue('_editable', formikProps.values, true);

    const isError = !noError && !!errorValue;

    let _label = label;
    if (required) _label += '*';

    const handleChange = (event, newValue) => {
        formikProps.setFieldValue(id, newValue.map(x => x.value));
        formikProps.setFieldTouched(id, true);
        onChange(newValue);
    };

    return (
        <Autocomplete
            className={className}
            noOptionsText={Tr('no_options')}
            onChange={handleChange}
            multiple
            //id={id}
            options={items}
            getOptionLabel={option => option.label}
            value={items.filter(x => value.includes(x.value))}
            filterSelectedOptions
            disableCloseOnSelect

            disabled={disabled || !editable}
            ChipProps={{
                onClick: onChipClick,
                title: chipTitle
            }}
            renderInput={params => {
                return <TextField
                    {...params}
                    variant="standard"
                    label={_label}
                    placeholder={Tr('recipients')}
                    fullWidth
                    helperText={noError ? undefined : isError ? errorValue : ' '}
                    error={isError}
                />
            }}

        />)

}

OrganizationsSelect.propTypes = {
    className: PropTypes.string,
    formikProps: PropTypes.object,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.shape({
                value: PropTypes.any.isRequired,
                label: PropTypes.string.isRequired,
            }),
            PropTypes.string.isRequired,
        ])
    ),
    onChipClick: PropTypes.func,
    chipTitle: PropTypes.string
}

OrganizationsSelect.defaultProps = {
    items: []
}

export default OrganizationsSelect
